import { InjectionToken } from '@angular/core';

export type AppConfig = {
  httpUrl: string;
  websocketUrl: string;
};

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

export async function loadAppConfig(): Promise<AppConfig> {
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Failed to load /config.json: ${response.status} ${response.statusText}`);
  }
  return (await response.json()) as AppConfig;
}
